/* eslint-disable react/jsx-key */
import moment from 'moment';
import React from 'react';
import {
  isAddress,
  isAlphaNumeric,
  isPassword,
  isName,
  isFullName,
  isHKPhoneNumber,
  isSGPhoneNumber,
  isHKId,
  isSGId,
  isTextCorrectLength,
  isNumberInRange,
  isNumberCorrectLength,
  isNumberLengthInRange,
  isEnglishCharactersOrSpace,
  isChineseCharactersOrEmpty,
  isSelection,
  isFieldMatch,
  isAlphaUppercaseNumeric,
  isEnglishCharactersOrSpaceOrSymbol,
  validateDob,
  validateExpiryDate,
  isSpecificLength,
  isNumberInDynamicRange,
  isMultipleOf,
} from 'helpers/ValidationUtil';
import { ValidationUtils } from '@hyphengroup/cag-components';
import _ from 'lodash';

const { isEmail } = ValidationUtils;
export const ValidationType = {
  TEXT_LENGTH: 'TEXT_LENGTH',
  REQUIRED: 'REQUIRED',
  NUMBER_RANGE: 'NUMBER_RANGE',
  NUMBER_LENGTH_RANGE: 'NUMBER_LENGTH_RANGE',
  ALPHA_NUMERIC: 'ALPHA_NUMERIC',
  DYNAMIC_NUMBER_RANGE: 'DYNAMIC_NUMBER_RANGE',
  MULTIPLE_OF: 'MULTIPLE_OF',
  ENGlISH_CHARACTERS: 'ENGLISH_CHARACTERS',
  ENGLISH_CHARACTERS_AND_SYMBOL: 'ENGLISH_CHARACTERS_AND_SYMBOL',
  CHINESE_CHARACTERS_OR_EMPTY: 'CHINESE_CHARACTERS_OR_EMPTY',
  EMAIL: 'EMAIL',
  NAME: 'NAME',
  FULL_NAME: 'FULL_NAME',
  PHONE: 'PHONE',
  SG_PHONE: 'SG_PHONE',
  ADDRESS: 'ADDRESS',
  PASSWORD: 'PASSWORD',
  DOB: 'DOB',
  EXPIRY_DATE: 'EXPIRY_DATE',
  HKID: 'HKID',
  SGID: 'SGID',
  CHECKED: 'CHECKED',
  NONE: 'NONE',
  SELECTION: 'SELECTION',
  MATCH_FIELD: 'MATCH_FIELD',
  ALPHA_UPPERCASE_NUMERIC: 'ALPHA_UPPERCASE_NUMERIC',
  SPECIFIC_LENGTH: 'SPECIFIC_LENGTH',
  NUMBER_LENGTH: 'NUMBER_LENGTH',
  FAMILY_MEMBERS: 'FAMILY_MEMBERS',
};

/*
    value,
    validation,
    formState,
    isRequired
    */
export const setValidationArray = (fieldState) => {
  const { validation, formState, isRequired } = fieldState;
  if (!validation) {
    return fieldState;
  }
  const val = validation.reduce((acc, check) => {
    switch (check.type) {
      case ValidationType.TEXT_LENGTH:
        return {
          isValid: !fieldState.value
            ? true
            : acc.isValid && isTextCorrectLength(fieldState.value, check.min, check.max),
          errorMessage:
            isTextCorrectLength(fieldState.value, check.min, check.max)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.NUMBER_RANGE:
        return {
          isValid: !fieldState.value && fieldState.value !== 0
            ? acc.isValid
            : acc.isValid && isNumberInRange(fieldState.value, check.min, check.max),
          errorMessage: (function() {
            const isValidNumber = isNumberInRange(fieldState.value, check.min, check.max);
            let error;
            switch (true) {
              case !fieldState.value && fieldState.value !== 0: { error = acc.errorMessage; break; }
              case !isValidNumber: { error = check.errorMessage; break; }
              case isValidNumber: { error = acc.errorMessage; break; }
              default: { error = acc.errorMessage; }
            }
            return error;
          })(),
        };
      case ValidationType.EMAIL:
        return {
          isValid: acc.isValid && isEmail(fieldState.value),
          errorMessage: isEmail(fieldState.value) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.PASSWORD:
        return {
          isValid: acc.isValid && isPassword(fieldState.value),
          errorMessage: isPassword(fieldState.value) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.REQUIRED:
        return {
          isValid: !!acc.isValid && fieldState.value !== undefined && fieldState.value !== null && fieldState.value !== '' && !Number.isNaN(fieldState.value),
          errorMessage: fieldState.value !== undefined && fieldState.value !== null && fieldState.value !== '' && !Number.isNaN(fieldState.value) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.ALPHA_NUMERIC:
        return {
          isValid: acc.isValid && (isAlphaNumeric(fieldState.value) || fieldState.value === ''),
          errorMessage: (isAlphaNumeric(fieldState.value) || fieldState.value === '') ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.DYNAMIC_NUMBER_RANGE: {
        const {
          valueTooLowMessage,
          valueTooHighMessage,
        } = check;
        const { isValidValue, errorMessage: dynamicErrorMessage } = isNumberInDynamicRange(
          fieldState.value,
          fieldState.dynamicErrorMessage,
          valueTooLowMessage,
          valueTooHighMessage,
        );
        return {
          isValid: fieldState.value ? acc.isValid && isValidValue : null,
          errorMessage:
            isValidValue || fieldState.value === ''
              ? acc.errorMessage : dynamicErrorMessage,
        };
      }
      case ValidationType.ENGlISH_CHARACTERS:
        return {
          isValid: acc.isValid && isEnglishCharactersOrSpace(fieldState.value),
          errorMessage:
            isEnglishCharactersOrSpace(fieldState.value)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.SPECIFIC_LENGTH:
        return {
          isValid: acc.isValid
            && (isSpecificLength(fieldState.value, check.min, check.max) || fieldState.value === ''),
          errorMessage:
            (isSpecificLength(fieldState.value, check.min, check.max) || fieldState.value === '')
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.NUMBER_LENGTH:
        return {
          isValid: acc.isValid
            && (isNumberCorrectLength(fieldState.value, check.min, check.max) || fieldState.value === ''),
          errorMessage:
            (isNumberCorrectLength(fieldState.value, check.min, check.max) || fieldState.value === '')
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.NUMBER_LENGTH_RANGE:
        return {
          isValid: acc.isValid
            && (isNumberLengthInRange(fieldState.value, check.min, check.max) || fieldState.value === ''),
          errorMessage:
            (isNumberLengthInRange(fieldState.value, check.min, check.max) || fieldState.value === '')
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.ENGLISH_CHARACTERS_AND_SYMBOL:
        return {
          isValid: acc.isValid && isEnglishCharactersOrSpaceOrSymbol(fieldState.value),
          errorMessage:
            isEnglishCharactersOrSpaceOrSymbol(fieldState.value)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.CHINESE_CHARACTERS_OR_EMPTY:
        return {
          isValid: acc.isValid && isChineseCharactersOrEmpty(fieldState.value),
          errorMessage:
            isChineseCharactersOrEmpty(fieldState.value)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.NAME:
        return {
          isValid: acc.isValid && isName(fieldState.value, check.forbiddenValues),
          errorMessage:
            isName(fieldState.value, check.forbiddenValues) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.FULL_NAME:
        return {
          isValid: acc.isValid && isFullName(fieldState.value, check.forbiddenValues),
          errorMessage:
            isFullName(fieldState.value, check.forbiddenValues)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.PHONE:
        return {
          isValid: acc.isValid
            && (isHKPhoneNumber(fieldState.value)
              || fieldState.value === null
              || fieldState.value === undefined
              || `${fieldState.value}`.length === 0),
          errorMessage: isHKPhoneNumber(fieldState.value) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.SG_PHONE:
        return {
          isValid: acc.isValid && isSGPhoneNumber(fieldState.value),
          errorMessage: isSGPhoneNumber(fieldState.value) ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.ADDRESS:
        return {
          isValid: acc.isValid
            && (isAddress(fieldState.value) || fieldState.value === ''),
          errorMessage:
            (isAddress(fieldState.value) || fieldState.value === '')
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.DOB: {
        const {
          invalidDateMessage,
          errorMessage,
          min,
          max,
          ageAtTheDateOf,
          format,
        } = check;
        const { isValidDate, errorMessage: dobErrorMessage } = validateDob(
          moment(fieldState.value, format),
          invalidDateMessage,
          errorMessage,
          min,
          max,
          invalidDateMessage,
          null,
          ageAtTheDateOf ? moment(ageAtTheDateOf) : null,
        );

        return {
          isValid: fieldState.value ? acc.isValid && isValidDate : null,
          errorMessage: ((function() {
            let error;
            switch (true) {
              case !fieldState.value: { error = null; break; }
              case !isValidDate: { error = dobErrorMessage; break; }
              case isValidDate: { error = acc.errorMessage; break; }
              default: { error = null; }
            }
            return error;
          })()),
        };
      }
      case ValidationType.MULTIPLE_OF: {
        const {
          errorMessage,
          multiple,
        } = check;
        return {
          isValid: fieldState.value ? acc.isValid
           && isMultipleOf(fieldState.value, multiple) : null,
          errorMessage: (acc.isValid && isMultipleOf(fieldState.value, multiple))
            ? acc.errorMessage : errorMessage,
        };
      }
      case ValidationType.EXPIRY_DATE: {
        const {
          errorMessage,
          invalidDateMessage,
          allowInThePast,
          maxYears,
          maxMonths,
        } = check;
        const { isValidDate, errorMessage: dobErrorMessage } = validateExpiryDate(
          moment(fieldState.value),
          errorMessage,
          invalidDateMessage,
          allowInThePast,
          maxYears,
          maxMonths,
        );

        return {
          isValid: fieldState.value ? acc.isValid && isValidDate : null,
          errorMessage: ((function() {
            let error;
            switch (true) {
              case !fieldState.value: { error = null; break; }
              case !isValidDate: { error = dobErrorMessage; break; }
              case isValidDate: { error = acc.errorMessage; break; }
              default: { error = null; }
            }
            return error;
          })()),
        };
      }
      case ValidationType.HKID:
        return {
          isValid: acc.isValid && (isHKId(fieldState.value) || fieldState.value === ''),
          errorMessage: (isHKId(fieldState.value) || fieldState.value === '') ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.SGID:
        return {
          isValid: acc.isValid && (isSGId(fieldState.value) || fieldState.value === ''),
          errorMessage: (isSGId(fieldState.value) || fieldState.value === '') ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.SELECTION:
        return {
          isValid: (acc.isValid && (isSelection(fieldState.value, check.options) || !isRequired)),
          errorMessage:
            isSelection(fieldState.value, check.options)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.MATCH_FIELD:
        return {
          isValid: acc.isValid && isFieldMatch(fieldState.value, formState[check.match].value),
          errorMessage:
            isFieldMatch(fieldState.value, formState[check.match].value)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.ALPHA_UPPERCASE_NUMERIC:
        return {
          isValid: acc.isValid && isAlphaUppercaseNumeric(fieldState.value),
          errorMessage:
            isAlphaUppercaseNumeric(fieldState.value)
              ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.FAMILY_MEMBERS: {
        let isValid = true;
        const { value } = fieldState;
        if (Array.isArray(value)) {
          value.forEach(member => {
            if (!member.isValid) {
              isValid = false;
            }
          });
        }
        return {
          isValid,
          errorMessage: 'Please fill in all family members',
        };
      }
      case ValidationType.CHECKED:
        return {
          isValid: acc.isValid && fieldState.value === true,
          errorMessage: fieldState.value ? acc.errorMessage : check.errorMessage,
        };
      case ValidationType.NONE:
        return {
          isValid: acc.isValid && true,
          errorMessage: acc.errorMessage,
        };
      default:
        return {
          isValid: acc.isValid && false,
          errorMessage: check.errorMessage,
        };
    }
  }, {
    isValid: true,
    errorMessage: '',
  });
  return {
    value: fieldState.value,
    errorMsg: val.errorMessage,
    validation: fieldState.validation,
    isValid: val.isValid,
    isRequired: fieldState.isRequired,
  };
};

/*
setFieldState is called from the onchange event of a form. via debounce function
  in Application page.
  value, value of form field
  validation, array of different validation types to be checked in function
  formState[page], Form & Field info
  field.isRequired, wether or not the field is required. Important for dropdowns/selects.
  field.mapping, path and config needed for mapping field for mutation.
*/
export const setFieldState = ({
  value,
  validation,
  formState,
  isRequired,
  mapping,
  hidden,
  dynamicErrorMessage,
}) => {
  const results = setValidationArray({
    value,
    validation,
    formState,
    isRequired,
    mapping,
    hidden,
    dynamicErrorMessage,
  });
  return {
    value: results.value,
    isValid: hidden ? true : results.isValid,
    message: results.isValid ? '' : results.errorMsg,
    isRequired,
    mapping,
  };
};

const isScrolledIntoView = (el, number = 0) => {
  const rect = el.getBoundingClientRect();
  const elemBottom = rect.bottom;

  return (elemBottom <= window.innerHeight + rect.height - number);

  // TODO(Ryan): Add condition to avoid the element height or class affect
  // return (elemBottom <= window.innerHeight);
};

// Updated to handle multiple buttons (back and fwd) not just one
export const handleScroll = () => {
  const possibleColumns = [...document.querySelectorAll('#button-column')];
  const row = document.getElementById('button-row');
  if (row.getBoundingClientRect().width > 350) {
    if (row && isScrolledIntoView(row, 90)) {
      possibleColumns.forEach((column) => {
        column.classList.remove('button-column');
        column.setAttribute('style', '');
      });
    } else if (row) {
      possibleColumns.forEach((column) => {
        column.classList.add('button-column');
        column.setAttribute('style', `min-width:0 !important; max-width:${row.getBoundingClientRect().width}px; width:${row.getBoundingClientRect().width}px;`);
      });
    }
  }

  if (isScrolledIntoView(document.getElementById('summary-row'))) {
    document.getElementById('summary-btn-column').classList.remove('summary-sticky');
  } else {
    document.getElementById('summary-btn-column').classList.add('summary-sticky');
  }
};

export const formatMoney = (rawMoneyAmount, currencySymbol = '$') => {
  if (!rawMoneyAmount && rawMoneyAmount !== 0) {
    return '';
  }
  const moneyAmount = `${rawMoneyAmount}`;
  let numCommas = Math.floor(moneyAmount.length / 3);
  let prefixNums = moneyAmount.length % 3;

  if (prefixNums === 0) {
    prefixNums = 3;
    numCommas -= 1;
  }

  let formattedAmount = currencySymbol ? `${currencySymbol}${moneyAmount.slice(0, prefixNums)}`
    : `${moneyAmount.slice(0, prefixNums)}`;

  let lastIndex = prefixNums;

  for (let i = 0; i < numCommas; i++) {
    formattedAmount += `,${moneyAmount.slice(lastIndex, lastIndex + 3)}`;
    lastIndex += 3;
  }

  return formattedAmount;
};

export const formatPhoneNumber = (phoneNumber) => {
  if (phoneNumber == null) {
    return '';
  }

  const reversedPhoneNumberArray = `${phoneNumber}`.split('').reverse();
  const reversedFormattedPhoneNumber = _.chunk(reversedPhoneNumberArray, 4)
    .map(chunk => chunk.join('')).join(' ');
  const formattedPhoneNumber = reversedFormattedPhoneNumber.split('').reverse().join('');
  return formattedPhoneNumber;
};

export const formatOptionValue = (options, value) => {
  if (options == null || value == null) {
    return '';
  }
  let displayValue = '';
  options.forEach((option) => {
    if (option.value === value) {
      displayValue = option.label;
    }
  });
  return displayValue;
};

export const formatOptionValueList = (options, value) => (!value || value.size < 1 ? '' : value.map(dest => formatOptionValue(options, dest)).join(', '));

export const formatDate = (givenDate, seperator) => {
  if (!givenDate) {
    return '';
  }
  const sep = seperator || '/';
  const dates = givenDate.split('-');
  return `${dates[2]}${sep}${dates[1]}${sep}${dates[0]}`;
};

export const formatValueWithLabel = (value, label) => {
  if (!value && value !== 0) {
    return '';
  }
  return `${value} ${label}`;
};

export const formatSingleValue = (formatType, value, arg) => {
  switch (formatType) {
    case 'phone': {
      return formatPhoneNumber(value);
    }
    case 'money': {
      return formatMoney(value, arg);
    }
    case 'option': {
      return formatOptionValue(arg, value);
    }
    case 'date': {
      return formatDate(value);
    }
    default: {
      return value === null || value === undefined ? '' : value;
    }
  }
};

export const formatValue = (formatType, value, arg) => {
  if (Array.isArray(value)) {
    if (value.length === 1) {
      return formatSingleValue(formatType, value[0], arg);
    }
    const listItems = value
      .map(val => formatSingleValue(formatType, val, arg))
      .map(val => <li className="formattedValueListItem">{val}</li>);
    return <div className="formattedValueList"><ul>{listItems}</ul></div>;
  }
  return formatSingleValue(formatType, value, arg);
};

export const formatField = (formatType, field) => {
  switch (formatType) {
    case 'phone': {
      return formatPhoneNumber(field?.value);
    }
    case 'sgPhoneNoSpace': {
      return `+65 ${field?.value}`;
    }
    case 'money': {
      return formatMoney(field?.value, field?.currencySymbol);
    }
    case 'option': {
      return formatOptionValue(field?.options, field?.value);
    }
    case 'date': {
      return formatDate(field?.value, '-');
    }
    default: {
      return field?.value;
    }
  }
};

export const formatYearAndMonth = (yearValue, yearLabel, monthValue, monthLabel) => {
  if (!yearValue && !monthValue && yearValue !== 0 && monthValue !== 0) {
    return '';
  }
  let yearOut = yearValue;
  let monthOut = monthValue;
  if (!yearValue) {
    yearOut = 0;
  }
  if (!monthValue) {
    monthOut = 0;
  }
  return `${yearOut} ${yearLabel} ${monthOut} ${monthLabel}`;
};

const titleOptions = require('staticConfig/titleOptions.json');
const mortgageTypeOptions = require('staticConfig/mortgageTypeOptions.json');
const propertyTypeOptions = require('staticConfig/propertyTypeOptions.json');
const yesNoOptions = require('staticConfig/yesNoOptions.json');
const loanPurposeOptions = require('staticConfig/loanPurposeOptions.json');
const genderOptions = require('staticConfig/genderOptions.json');
const maritalStatusOptions = require('staticConfig/maritalStatusOptions.json');
const residentialStatusOptions = require('staticConfig/residentialStatusOptions.json');
const numberOfDependenciesOptions = require('staticConfig/numberOfDependenciesOptions.json');
const industryOptions = require('staticConfig/industryOptions.json');
const occupationOptions = require('staticConfig/occupationOptions.json');
const employmentStatusOptions = require('staticConfig/employmentStatusOptions.json');
const hkAddressDistrictLevelOptions = require('staticConfig/hkAddressDistrictLevelOptions.json');
const contactTimeOptions = require('staticConfig/contactTimeOptions.json');
const paymentMethodOptions = require('staticConfig/paymentMethodOptions.json');
const countryOptions = require('staticConfig/countryOptions.json');
const nationalityOptions = require('staticConfig/nationalityOptions.json');
const educationLevelOptions = require('staticConfig/educationLevelOptions.json');
const documentTypeOptions = require('staticConfig/documentTypeOptions.json');
const preferredCreditLimitOptions = require('staticConfig/preferredCreditLimitOptions.json');
const sgResidencyStatusOptions = require('staticConfig/sgResidencyStatusOptions.json');
const scbSgEmploymentStatusOptions = require('staticConfig/scbSgEmploymentStatusOptions.json');
const scbSgCountryOptions = require('staticConfig/scbSgCountryOptions.json');
const scbSgNationalityOptions = require('staticConfig/scbSgNationalityOptions.json');
const scbSgCountryCodeOptions = require('staticConfig/scbSgCountryCodeOptions.json');

const allFieldOptions = {
  titleOptions,
  mortgageTypeOptions,
  propertyTypeOptions,
  yesNoOptions,
  loanPurposeOptions,
  genderOptions,
  maritalStatusOptions,
  residentialStatusOptions,
  numberOfDependenciesOptions,
  industryOptions,
  occupationOptions,
  employmentStatusOptions,
  hkAddressDistrictLevelOptions,
  contactTimeOptions,
  paymentMethodOptions,
  countryOptions,
  nationalityOptions,
  educationLevelOptions,
  documentTypeOptions,
  preferredCreditLimitOptions,
  sgResidencyStatusOptions,
  scbSgEmploymentStatusOptions,
  scbSgCountryOptions,
  scbSgNationalityOptions,
  scbSgCountryCodeOptions,
};

export const getFieldOptions = (optionsKey, language) => _.get(allFieldOptions, `${optionsKey}.options.${language}.entries`);

export const removeParenthesis = value => (!value ? '' : value.replace(/[()]/g, ''));

export const normaliseHKID = value => (!value ? '' : removeParenthesis(value).toUpperCase());
